module.exports = __webpack_public_path__ + "static/media/icomoon.b80aadd2.ttf";